import React from 'react';
import { Button } from './ui/button';
import makeup from "../assets/images/g5.jpg";

const PartyMakeup = () => {
  return (
    <div className="pt-20">
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Party Makeup Services</h1>
              <p className="text-gray-700 leading-relaxed mb-4">
                Look stunning at your next event with our professional party makeup services. Our expert makeup artists create the perfect look for any occasion.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                From elegant evening looks to glamorous party styles, we ensure you shine at every celebration.
              </p>
              <Button
                className="bg-black hover:bg-gray-800 text-white px-8 py-4 rounded-full"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Book Appointment
              </Button>
            </div>
            <div>
              <img src={makeup} alt="Party Makeup" className="rounded-lg shadow-xl w-full h-[500px] object-cover" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PartyMakeup;
